/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Typography } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../components/table/Table";
import {
  getCompanyData,
  getCompanyHmoHistory,
  setPagination,
} from "../../../features/company/companySlice";
import HomeLayout from "../../../layouts/Home";
import { capitalize, getAmount, getIds } from "../../../utils/helper";

const HmoHistory = () => {
  const { loading, pagination, hmoTransactionHistory } =
      useSelector(getCompanyData),
    dispatch = useDispatch();
  useEffect(() => {
    (async () => await dispatch(getCompanyHmoHistory(getIds().company)))();
  }, [pagination.page]);

  const data = hmoTransactionHistory?.map((data) => ({
    "Payment ref.": data.paymentReference,
    "Plan Name": capitalize(data?.planDetails?.name),
    "HMO Name": capitalize(data?.payeeDetails?.name),
    "Amount Per Plan": "₦" + getAmount(data?.planDetails?.amount),
    "Plan Duration": data?.planDetails?.duration,
    _data: data,
  }));

  return (
    <HomeLayout
      {...{
        title: "Transaction Management",
        subtitle: "Overview  of all information on the system.",
      }}
    >
      <Box className="ml-3">
        <Typography className="text-[400] text-xl mt-8 mb-5  text-[#040316]">
          H. M. O Transaction History
        </Typography>
      </Box>

      <Box
        className="pt-8 px-8 mt-14 pb-2 bg-[var(--c-bg-color)] rounded-lg w-100%"
        sx={{ p: 0 }}
      >
        {/* {loading ? (
          <TablePreloader />
        ) : data?.length ? ( */}
        <Table
          {...{
            data,
            pagination,
            setPagination: (data) => dispatch(setPagination(data())),
            isLoading: loading,
          }}
        />
        {/* ) : (
          <Box
            className="pt-8 pb-28 mt-8 bg-[var(--c-bg-color)] w-100% rounded-lg flex flex-col justify-center"
            sx={{ p: 0 }}
          >
            <img
              className="m-auto w-[350px] mt-8"
              src={IError}
              alt={"error"}
              loading="lazy"
            />
            <Typography className="flex justify-center text-[400] text-xl text-[#040316] mx-2 text-center">
              No Transaction in the system at the moment
            </Typography>
          </Box>
        )} */}
      </Box>
    </HomeLayout>
  );
};

export default HmoHistory;
